import ThemeApplicator from "@/components/ThemeApplicator";
import MatrixRain from "@/components/MatrixRain";
import NeonBackground from "@/components/NeonBackground";
import SakuraPetals from "@/components/SakuraPetals";
import CyberpunkBackground from "@/components/CyberpunkBackground";
import { useGamificationStore } from "@/stores/useGamificationStore";

/** Renders theme logic and overlays at app level so they work on all routes (including public pages). */
export default function AppThemeWrapper() {
  const equippedTheme = useGamificationStore((s) => s.equippedTheme);

  return (
    <>
      <ThemeApplicator />
      {equippedTheme === "matrixTheme" && <MatrixRain />}
      {equippedTheme === "neonTheme" && <NeonBackground />}
      {equippedTheme === "sakuraTheme" && <SakuraPetals />}
      {equippedTheme === "cyberpunkTheme" && <CyberpunkBackground />}
    </>
  );
}
